import { render, staticRenderFns } from "./tabela-rent-benchmark.vue?vue&type=template&id=5ebf78f1&scoped=true&"
import script from "./tabela-rent-benchmark.vue?vue&type=script&lang=js&"
export * from "./tabela-rent-benchmark.vue?vue&type=script&lang=js&"
import style0 from "./tabela-rent-benchmark.vue?vue&type=style&index=0&id=5ebf78f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf78f1",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ebf78f1')) {
      api.createRecord('5ebf78f1', component.options)
    } else {
      api.reload('5ebf78f1', component.options)
    }
    module.hot.accept("./tabela-rent-benchmark.vue?vue&type=template&id=5ebf78f1&scoped=true&", function () {
      api.rerender('5ebf78f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabela-rent-benchmark.vue"
export default component.exports